import React, { useState } from "react";
import styled from "@emotion/styled";
import { Button, Flex, ImportantInfoCard, InputBirthDate, Loader, Text } from "src/components";
import { colors } from "src/theme";
import { breakpoints, i18n, mediaQuery } from "src/common";
import BookmarkIcon from "src/assets/images/bookmark.svg";
import { Card } from "./card";

const CardStyle = styled(Card)({
  position: 'relative',
  padding: '16px',
  paddingTop: '48px',

  [mediaQuery('tablet')]: {
    padding: '32px'
  },

  [mediaQuery('laptopL')]: {
    padding: '40px',
  }
})

const BookmarkStyle = styled.img({
  position: 'absolute',
  top: 0,
  right: 24,
  width: 23,
  height: 36,

  [mediaQuery('tablet')]: {
    right: 32,
  },

  [mediaQuery('laptopL')]: {
    right: 40,
  },
})

const TextStyle = styled(Text)({
  [mediaQuery('laptopL')]: {
    textAlign: 'center',
  }
})

const PriceRowStyle = styled(Flex)({
  flexDirection: 'column',
  gap: 12,

  [mediaQuery('mobile')]: {
    flexDirection: 'row',
    alignItems: 'center',
  },
})

const BirthDateWrapper = styled.div({
  position: 'relative',
})

const ChangeDateButtonWrapper = styled.div({
  position: 'absolute',
  top: '50%',
  right: 12,
  transform: 'translateY(-50%)',
})

export interface BestPriceCardProps {
  price?: number;
  className?: string;
  birthDate?: string;
  onContractNow?: () => void;
  onBirthDateChange?: (value: string) => void;
}

export const BestPriceCard = ({ price, className, birthDate, onContractNow, onBirthDateChange }: BestPriceCardProps) => {
  const [isBirthDateEditable, setIsBirthDateEditable] = useState(false);

  const mobileBreak = window.innerWidth < breakpoints.mobile;

  return (
    <CardStyle className={className}>
      <BookmarkStyle src={BookmarkIcon} alt="Bookmark" />
      <Flex vertical gap={'12px'}>
        <TextStyle type="large" bold>{i18n.t(`components.cards.bestPriceCard.title${mobileBreak ? 'Short' : ''}`)}</TextStyle>
        {!price && <Loader />}
        {price && (
          <Flex vertical gap={2}>
            <PriceRowStyle gap={12}>
              <ImportantInfoCard price={price} />
              <Button
                btnType="outlinePrimary"
                size="extralarge"
                text={i18n.t('components.cards.bestPriceCard.contractNow')}
                onClick={() => {
                  gtag('event', 'DZO_Contract_Now', {
                    product_category: 'Zdravstveno osiguranje',
                    product_name: 'Dopunsko osiguranje',
                    user_action: 'contractNow',
                    send_to: 'G-W4DJP1J8F5',
                  });
                  if (onContractNow) onContractNow();
                }}
              />
            </PriceRowStyle>
            <Flex align="center" gap={8}>
              <TextStyle type="micro" color={colors.text3}>{i18n.t('components.cards.bestPriceCard.description')}</TextStyle>
            </Flex>
          </Flex>
        )}
        <BirthDateWrapper>
          <InputBirthDate
            value={birthDate}
            disabled={!isBirthDateEditable}
            onChange={onBirthDateChange}
          />
          <ChangeDateButtonWrapper>
            <Button
              btnType="textBlack"
              size="small"
              text={i18n.t(`components.cards.bestPriceCard.changeDateOfBirth${mobileBreak ? 'Short' : ''}`)}
              onClick={() => setIsBirthDateEditable(true)}
              style={{
                color: colors.text4,
                textDecoration: 'underline',
                textDecorationColor: colors.text4
              }}
            />
          </ChangeDateButtonWrapper>
        </BirthDateWrapper>
      </Flex>
    </CardStyle>
  );
}
